import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import SimpleModal from '../Modals/SimpleModal'

const FatalErrorModal = ({ error, onBack, onGoHome }) => <SimpleModal
  isShown={error}
  title={<FormattedMessage defaultMessage='Se ha producido un error' />}
  subtitle={<FormattedMessage defaultMessage='Por favor reinicia el proceso' />}
  imageSrc='/images/rental-car/no-results.svg'
  onClose={onBack || onGoHome}
  onAccept={onBack || onGoHome}
  acceptButtonText={<FormattedMessage defaultMessage='De acuerdo' />} />

FatalErrorModal.defaultProps = {
    error: false,
    onBack: () => { document.location = '/' },
}

FatalErrorModal.propTypes = {
    error: PropTypes.bool,
    onBack: PropTypes.func,
    onGoHome: PropTypes.func,
}
export default FatalErrorModal
